import Container from "../../../../layouts/containers/container";
import Row from "../../../../components/row";
import Stats from "../../../../components/stats";

export default function Banner() {
    return (
        <div className="banner">
            <Container className="banner__item banner__credits">
                <Container.Header>
                    <Row gap='10px'>
                        <Container.Icon src={'/assets/icons/co-working-credits.svg'}/>
                        <Container.Text fontSize="20px" color="white" fontWeight='500'>Your Co-Working Credits</Container.Text>
                    </Row>
                </Container.Header>

                <Container.Content>
                    <Row gap="40px" className="banner-item__inner">
                        <Stats center valueColor="white" titleColor="#00C8C3" title="Used" value='9999'/>
                        <Stats center valueColor="white" titleColor="#00C8C3" title="Remaining (Current Month)" value='Unlimited' />
                    </Row>
                </Container.Content>
            </Container>

            <Container className="banner__item banner__information">
                <Container.Header>
                    <Container.Text fontSize="25px" color="#FF6933">Discover our incredible Memberships</Container.Text>
                </Container.Header>
                <Container.Content>
                    <Container.Text fontSize="16px" color="#354859">Text about event hosts. Text about event hosts. Text about event hosts. Text about event hosts.</Container.Text>
                </Container.Content>
            </Container>
        </div>
    )
}